// 弹窗数据
export interface PopupDataType {
  scene?: number
  link?: string
  attr?: {
    imageUrl?: string // 展示图片
    id?: number // 弹窗记录ID
    activityId?: number // 弹窗活动ID
    closeable?: number // 是否可关闭 0否 1是
    activityType?: number // 活动类型/活动标签 1优惠券,2图文触达
    deliveryStyle?: string // 触达类型,触达弹窗样式
    deliveryPage?: string // 展示页面,多个页面通过逗号隔开
    deliveryOs?: string // 设备类型 6：h5
    weight?: number // 权重,数值越大优先级越高
    fatigueValue?: number // 疲劳值
    displaySeconds?: number // 自动展示时间,单位秒 -1为始终展示
    expireAt?: number // 过期时间
  }
}

// 页面名称转换枚举
export const enum POPUP_PAGE_NAME {
  techlist_page = 'technicianList', // 技师列表页
  techdetail_page = 'technicianDetail', // 技师详情页
  refund_complete_page = 'refundDetail', // 退款完成页
  payment_complete_page = 'orderPaySuccess', // 支付完成页
  home_page = 'homeModule', // 首页
  my_page = 'myModuleHome', // 我的页面
  orderlist_page = 'myOrders', // 订单列表页
  dynamicdetail_page = 'trendsDetail', // 动态作品页
}
